<div class="modal" *ngIf="!hideModal">
  <div class="container model-container {{data.customClass}}">
    <div class="modal-header">
      <img src="assets/icon/primary-close.svg" (click)="cancel()" class="modal-close" width="32" height="32" alt="Close Icon">
      <h4 class="modal-heading" translate>change-email-modal.title</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <p class="smaller text-content" translate>change-email-modal.enter-new-email</p>

        <form [formGroup]="emailForm">
          <label class="outlined-label-input">
            <input type="email" (input)="credentialsError = false;" formControlName="email" placeholder=" ">
            <span translate>change-email-modal.new-email <span class="star">*</span></span>
          </label>

          <p *ngIf="emailForm.controls['email'].touched && emailForm.controls['email'].hasError('required')"
            class="validation-message" translate>
            change-email-modal.email-required
          </p>
          <p *ngIf="emailForm.controls['email'].touched && emailForm.controls['email'].hasError('pattern')"
            class="validation-message" translate>
            change-email-modal.email-invalid
          </p>

          <label class="outlined-label-input second" [class.input-error]="credentialsError">
            <input (input)="credentialsError = false" [type]="showPassword ? 'text' : 'password'"
              formControlName="password" placeholder=" " autocomplete="new-password">
            <span translate>login.password <span class="star hide">*</span></span>

            <img class="eye" [src]="showPassword ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="showPassword = !showPassword" *ngIf="emailForm.controls['password'].value" alt="eye icon"
              height="16" width="16">
          </label>

          <p *ngIf="emailForm.controls['password'].touched && emailForm.controls['password'].hasError('required')"
            class="validation-message" translate>
            login.password-required
          </p>

          <p *ngIf="credentialsError" class="validation-message" translate>change-email-modal.invalid-password</p>
      </form>
      </div>

      <div class="modal-actions">
        <button class="button primary" (click)="updateEmail()" translate>
          change-email-modal.update
        </button>
        <button class="button tertiary" (click)="cancel()" translate>
          change-email-modal.cancel
        </button>
      </div>
    </div>
  </div>
</div>
